export enum LabelLanguage {
  English = 1,
  French = 2,
  BilingualEnglishFirst = 3,
  BilingualFrenchFirst = 4
}
